// AbnerLogin.jsx
import React, { useState } from 'react';
import { 
  CheckCircle, 
  ArrowRight, 
  Shield, 
  Zap, 
  Users, 
  Mail, 
  Lock, 
  Eye, 
  EyeOff,
  User,
  Building,
  Award,
  Sparkles
} from 'lucide-react';
import Navbar from './Navbar';
import './Innovatorshome.css';
import InvoterFeatureSection from './InvoterFeatureSection';
import  CTA from './CTA';
import Footer from'./Footer';

const AbnerLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate login
    setTimeout(() => {
      setIsLoading(false);
      alert('✅ Login successful! Welcome to APIC ProtoHub.');
    }, 1500);
  };

  // Social Login Handlers
  const handleGoogleLogin = () => {
    alert('🔵 Google Sign-In initiated. Redirecting to Google...');
    // In production, redirect to Google OAuth
    // window.location.href = 'https://accounts.google.com/o/oauth2/auth?...';
  };

  const handleFacebookLogin = () => {
    alert('🔵 Facebook Sign-In initiated. Redirecting to Facebook...');
    // In production, redirect to Facebook OAuth
    // window.location.href = 'https://www.facebook.com/v12.0/dialog/oauth?...';
  };

  const handleGithubLogin = () => {
    alert('⚫ GitHub Sign-In initiated. Redirecting to GitHub...');
    // In production, redirect to GitHub OAuth
    // window.location.href = 'https://github.com/login/oauth/authorize?...';
  };

  return (
    <>
      <Navbar />
      <section className="abner-login-section">
        {/* Background Image with Overlay */}
        <div className="abner-background">
          <img
            src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1600&q=80"
            alt="Industrial machinery background"
            className="abner-bg-image"
            loading="eager"
          />
          <div className="abner-overlay"></div>
          <div className="abner-glow-1"></div>
          <div className="abner-glow-2"></div>
        </div>

        {/* Content */}
        <div className="abner-content">
          <div className="abner-container">
            {/* Left Side - Text Content */}
            <div className="abner-left">
              {/* Badge */}
              <div className="abner-badge">
                <Shield size={14} className="abner-badge-icon" />
                <span>Innovator's Portal</span>
              </div>

              {/* Heading */}
              <h1 className="abner-heading">
                <span className="abner-heading-line1">Innovators</span>
                <span className="abner-heading-line2">Assembly</span>
              </h1>

              {/* Description */}
              <p className="abner-description">
                Join the future of manufacturing innovation. Access cutting-edge 
                machinery and collaborate with experts.
              </p>

              {/* Stats */}
              <div className="abner-stats">
                <div className="abner-stat-item">
                  <div className="abner-stat-icon">
                    <Users size={16} />
                  </div>
                  <div>
                    <p className="abner-stat-number">2.5K+</p>
                    <p className="abner-stat-label">Innovators</p>
                  </div>
                </div>
                <div className="abner-stat-divider"></div>
                <div className="abner-stat-item">
                  <div className="abner-stat-icon">
                    <Award size={16} />
                  </div>
                  <div>
                    <p className="abner-stat-number">150+</p>
                    <p className="abner-stat-label">Machines</p>
                  </div>
                </div>
                <div className="abner-stat-divider"></div>
                <div className="abner-stat-item">
                  <div className="abner-stat-icon">
                    <Building size={16} />
                  </div>
                  <div>
                    <p className="abner-stat-number">12</p>
                    <p className="abner-stat-label">Centres</p>
                  </div>
                </div>
              </div>

              {/* Features */}
              <ul className="abner-features">
                <li className="abner-feature-item">
                  <CheckCircle size={14} className="abner-feature-icon" />
                  <span>Premium industrial machinery access</span>
                </li>
                <li className="abner-feature-item">
                  <Zap size={14} className="abner-feature-icon" />
                  <span>Real-time booking & availability</span>
                </li>
                <li className="abner-feature-item">
                  <Users size={14} className="abner-feature-icon" />
                  <span>Connect with industry experts</span>
                </li>
              </ul>

              {/* Trust Badge */}
              <div className="abner-trust">
                <div className="abner-trust-avatars">
                  <div className="abner-avatar">A</div>
                  <div className="abner-avatar">B</div>
                  <div className="abner-avatar">C</div>
                  <div className="abner-avatar">D</div>
                  <div className="abner-avatar-more">+2k</div>
                </div>
                <div>
                  <p className="abner-trust-text">Trusted by 2,000+ innovators</p>
                  <p className="abner-trust-sub">Join the community</p>
                </div>
              </div>
            </div>

            {/* Right Side - Login Form */}
            <div className="abner-right">
              <div className="abner-form-card">
                <div className="abner-form-header">
                  <h2 className="abner-form-title">Welcome Back</h2>
                  <p className="abner-form-subtitle">Sign in to your innovator dashboard</p>
                </div>

                <form onSubmit={handleSubmit} className="abner-form">
                  {/* Email Field */}
                  <div className="abner-form-group">
                    <label className="abner-form-label">
                      <Mail size={14} />
                      Email Address
                    </label>
                    <div className="abner-input-wrapper">
                      <Mail size={16} className="abner-input-icon" />
                      <input
                        type="email"
                        className="abner-form-input"
                        placeholder="innovator@apic.in"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  {/* Password Field */}
                  <div className="abner-form-group">
                    <label className="abner-form-label">
                      <Lock size={14} />
                      Password
                    </label>
                    <div className="abner-input-wrapper">
                      <Lock size={16} className="abner-input-icon" />
                      <input
                        type={showPassword ? 'text' : 'password'}
                        className="abner-form-input"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <button
                        type="button"
                        className="abner-password-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                      </button>
                    </div>
                  </div>

                  {/* Remember Me & Forgot Password */}
                  <div className="abner-form-options">
                    <label className="abner-checkbox-label">
                      <input
                        type="checkbox"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                        className="abner-checkbox"
                      />
                      <span>Remember me</span>
                    </label>
                    <a href="#" className="abner-forgot-link">Forgot password?</a>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="abner-submit-btn"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span className="abner-spinner"></span>
                        Signing in...
                      </>
                    ) : (
                      <>
                        Sign In
                        <ArrowRight size={16} />
                      </>
                    )}
                  </button>

                  {/* Divider */}
                  <div className="abner-divider">
                    <span>Or continue with</span>
                  </div>

                  {/* Social Login - With Functionality */}
                  <div className="abner-social-login">
                    <button 
                      type="button" 
                      className="abner-social-btn google-btn"
                      onClick={handleGoogleLogin}
                    >
                      <svg className="abner-social-icon" viewBox="0 0 24 24">
                        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
                        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                      </svg>
                      Google
                    </button>
                    <button 
                      type="button" 
                      className="abner-social-btn facebook-btn"
                      onClick={handleFacebookLogin}
                    >
                      <svg className="abner-social-icon" viewBox="0 0 24 24">
                        <path fill="#1877F2" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                      </svg>
                      Facebook
                    </button>
                    <button 
                      type="button" 
                      className="abner-social-btn github-btn"
                      onClick={handleGithubLogin}
                    >
                      <svg className="abner-social-icon" viewBox="0 0 24 24">
                        <path fill="#000" d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.15 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.62.24 2.85.12 3.15.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
                      </svg>
                      GitHub
                    </button>
                  </div>

                  {/* Sign Up Link */}
                  <p className="abner-signup-link">
                    Don't have an account? <a href="#">Sign up now</a>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <InvoterFeatureSection/>
      <CTA />
            <Footer />
    </>
  );
};

export default AbnerLogin;